var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDummyImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 452 281",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M308.68 280.333H136.32c-5.69 0-10.32-4.63-10.32-10.32V51.32c0-5.691 4.63-10.32 10.32-10.32h19.347v4H136.32a6.327 6.327 0 00-6.32 6.32v218.693a6.327 6.327 0 006.32 6.32h172.36a6.327 6.327 0 006.32-6.32V249h4v21.013c0 5.69-4.63 10.32-10.32 10.32",
    fill: "#7190EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.366 4H160a3.999 3.999 0 00-4 4v238c0 1.061.421 2.078 1.172 2.828A3.995 3.995 0 00160 250h173a3.995 3.995 0 002.828-1.172A3.995 3.995 0 00337 246V51.68L288.366 4zm-93.192 129.438l-12.931-12.932a2.005 2.005 0 00-2.18-.434 2.005 2.005 0 00-1.083 2.614c.101.243.248.463.434.649l16.97 16.97a2.005 2.005 0 002.181.434c.243-.101.463-.248.649-.434l17.091-17.092a1.998 1.998 0 00-.024-2.804 2.002 2.002 0 00-2.804-.024l-14.229 14.228c-1-14.055 4.037-27.945 14.229-38.136 19.135-19.136 50.16-19.136 69.296 0 19.136 19.135 19.136 50.16 0 69.296-19.136 19.136-50.16 19.136-69.296 0l-2.829 2.829c20.698 20.697 54.256 20.697 74.954 0 20.697-20.698 20.697-54.256 0-74.954-20.698-20.698-54.256-20.698-74.954 0-10.669 10.67-16.117 25.092-15.474 39.79zM160 0h130l51 50v196a8 8 0 01-8 8H160a8 8 0 01-8-8V8a8.001 8.001 0 018-8zm129 4h-4v52.157h52.007v-3.925H289V4zm-46 106a2 2 0 00-4 0v31.519a2 2 0 002 2h30.331a2 2 0 000-4H243V110z",
    fill: "#7190EB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.5 169c0-27.21-5.293-32.5-32.5-32.5 27.207 0 32.5-5.29 32.5-32.5 0 27.21 5.29 32.5 32.5 32.5-27.21 0-32.5 5.29-32.5 32.5zm332-32c0-20.512-3.99-24.5-24.5-24.5 20.51 0 24.5-3.988 24.5-24.5 0 20.512 3.988 24.5 24.5 24.5-20.512 0-24.5 3.988-24.5 24.5z",
    fill: "#F1F2FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 241c-8.837 0-16-7.163-16-16s7.163-16 16-16 16 7.163 16 16-7.163 16-16 16zm0-5c6.075 0 11-4.925 11-11s-4.925-11-11-11-11 4.925-11 11 4.925 11 11 11zm425-27c-6.075 0-11-4.925-11-11s4.925-11 11-11 11 4.925 11 11-4.925 11-11 11zm0-5a6.003 6.003 0 004.243-1.757 6.003 6.003 0 000-8.486 6.003 6.003 0 00-8.486 0 6.003 6.003 0 000 8.486A6.003 6.003 0 00441 204z",
    fill: "#F1F2FA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h452v281H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDummyImage);
export default __webpack_public_path__ + "static/media/dummyImage.b4167d4ba0df7168b2d1ed1690751cf6.svg";
export { ForwardRef as ReactComponent };